import { CallMergeIcon } from './CallMergeIcon';

/**
 * author: Google
 * id 8BEE5A5E-EC0A-4FC5-96BE-7F8C2A2EE52F
 * name call-merge
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/call-merge.svg
 * tags
 * - Cellphone / Phone 
 * - Arrow 
 */
export const MergeTypeIcon = CallMergeIcon;
export default MergeTypeIcon